var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showHeader)?_c('AppHeader'):_vm._e(),_c('main',{class:['min-h-screen', _vm.showHeader ? 'header-offset py-8' : '']},[_c('router-view')],1),(_vm.showHeader)?_c('AppFooter'):_vm._e(),_c('AiWidget'),_c('TokenDebug')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }